"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.CONSOLIDATED_ADD_CARD = exports.ADD_CARD = void 0;
exports.ADD_CARD = {
    HEADER: 'Add a card',
    BODY: '',
    CARD_DETAILS: 'Card details',
    FEE_INFO: '',
    BILLING_INFO: 'Billing information',
    CHANGE: 'Change',
    DATA_SECURE: 'Your data is secured by bank-level encryption',
    CTA: 'Confirm card'
};
exports.CONSOLIDATED_ADD_CARD = __assign(__assign({}, exports.ADD_CARD), { HEADER: 'Let’s add your card', BODY: 'Add the card you’d like to use for your payments and membership fee. Don’t worry, we won’t charge you until your rent is due.', CARD_DETAILS: 'Card details', FEE_INFO: 'Flex charges a {{bpFee}}% bill payment fee on the total rent amount. An additional {{creditCardFee}}% processing fee will be applied when paying with a credit card.', CTA: 'Add' });
